/* Herbruikbare horizontale carrousel met pijlknoppen.
   Gebruik:
   <dm-carousel>
     <button data-dm-prev>...</button>
     <div class="dm-carousel">...items...</div>
     <button data-dm-next>...</button>
   </dm-carousel>
   De knoppen mogen ook buiten de track staan zolang ze binnen <dm-carousel> vallen.
   IIFE-guard: meerdere secties laden dit bestand; dubbel uitvoeren mag niet knallen. */
(function () {
if (customElements.get('dm-carousel')) return;
class DmCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.dm-carousel');
    this.prevButton = this.querySelector('[data-dm-prev]');
    this.nextButton = this.querySelector('[data-dm-next]');
    if (!this.track) return;

    this.prevButton?.addEventListener('click', () => this.scrollByPage(-1));
    this.nextButton?.addEventListener('click', () => this.scrollByPage(1));
    this.track.addEventListener('scroll', this.updateButtons.bind(this), { passive: true });
    window.addEventListener('resize', this.updateButtons.bind(this), { passive: true });
    this.updateButtons();
  }

  scrollByPage(direction) {
    const item = this.track.querySelector(':scope > *');
    const step = item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
    /* data-dm-step: aantal items per klik (standaard 2; 1 voor full-width sliders) */
    const itemsPerClick = parseInt(this.dataset.dmStep || '2', 10);
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: direction * step * itemsPerClick, behavior: smooth ? 'smooth' : 'auto' });
  }

  updateButtons() {
    if (!this.prevButton && !this.nextButton) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
    this.prevButton?.toggleAttribute('disabled', this.track.scrollLeft <= 2);
    this.nextButton?.toggleAttribute('disabled', this.track.scrollLeft >= maxScroll);
  }
}

customElements.define('dm-carousel', DmCarousel);
})();
